<template>
	<div
		v-if="loading"
		class="ao-preview d-flex align-center justify-center"
	>
		<v-progress-circular
			indeterminate
			size="64"
			width="4"
			color="primary"
		/>
	</div>
	<div
		v-else
		class="ao-preview px-4 px-md-6 py-4 py-md-8"
	>
		<slot
			v-if="loaded"
		/>
	</div>
</template>
<script>
export default {
	name: 'PreviewWrapper',
	props: {
		loading: {
			type: Boolean,
		},
		loaded: {
			type: Boolean,
			default: true,
		},
	},
}
</script>
<style scoped lang="scss">
.ao-preview {
	background: white;
	z-index: 1;
	min-height: 100vh;
}
</style>
